import { ChangeEvent, FC } from "react";
import { Input } from "@chakra-ui/react";
import { useField } from "formik";
import { InputWrapperSimple } from "./InputWrapperSimple";

interface Props {
  id: string;
  isDisabled?: boolean;
  label?: string;
  fontSize?: string;
  maxLength?: number;
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

export const StringInput: FC<Props> = ({
  id,
  label,
  maxLength,
  placeholder,
  ...props
}) => {
  const [field, meta] = useField(id);
  const type = "string";
  const inputId = `${type}-input-${id}`;

  return (
    <InputWrapperSimple label={label} meta={meta} id={id} type={type}>
      <Input
        {...field}
        id={inputId}
        isInvalid={meta.touched && !!meta.error}
        maxLength={maxLength}
        placeholder={placeholder}
        variant="th-short-text"
        {...props}
      />
    </InputWrapperSimple>
  );
};
